module.exports = __webpack_public_path__ + "img/egk_logo.png";